import DataTableInvoicingData from "./data-table";
import { useSelector } from "react-redux";
import { clientSelector } from "@/redux/clients/clients.selector";
import { InvoicingDataColumns, useInvoicingDataColumns } from "./columns";
import { Factura } from "@/redux/clients/types/Clients.interface";
import { TableSkeleton } from "@/components/ui/loading";

const InvoicingDataPage = () => {
  const { folderData, loading } = useSelector(clientSelector).ui;
  const columnsInvoicingData = useInvoicingDataColumns();

  const dataInvoicingData =
    (folderData &&
      folderData.carpetas.length > 0 &&
      folderData.carpetas[0].facturas.map((factura: Factura) => ({
        tipo: factura.tipoFactura,
        numero: factura.nroFactura,
        fecha: factura.fechaFactura,
        total: factura.totalDocumento,
        moneda: factura.moneda,
        serie: factura.serieFactura,
      }))) ||
    [];

  return (
    <div className="container pb-2 mt-2 min-w-full">
      {loading ? (
        <TableSkeleton rows={6} columns={6} />
      ) : (
        <DataTableInvoicingData
          columns={columnsInvoicingData}
          data={dataInvoicingData as InvoicingDataColumns[]}
        />
      )}
    </div>
  );
};

export default InvoicingDataPage;
